import { Component, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@shared/services/translate';
import { Client } from '@shared/models/client/client.class';
import { StorageService } from '@shared/services';
import { NgClass } from '@angular/common';
import { LanguageSelectorComponent } from '../../../../shared/components/v2/language-selector/language-selector.component';
import { Tooltip } from 'primeng/tooltip';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';
import { SbIcon } from '../../../../shared/components/v2/icon/icon.component';

@Component({
    selector: 'client-profile',
    templateUrl: './client-profile.component.html',
    styleUrls: ['./client-profile.component.scss'],
    imports: [NgClass, LanguageSelectorComponent, Tooltip, TranslatePipe, SbIcon]
})
export class ClientProfileComponent {
  @Input() activeProgress: boolean = false;
  @Input() supportedLanguages: any[] = [];
  @Input() currentClient: Client;
  @Input() isSmallScreen: boolean = false;

  @Output() showStoresHandler = new EventEmitter<{ open: boolean; event?: Event }>();
  @Output() emitLang: EventEmitter<string> = new EventEmitter<string>();
  @Output() uploadHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() sideBarSizeChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  private sideBarToolTip = [
    'FORM.ACTIONS.CLOSE',
    'FORM.ACTIONS.OPEN'
  ];

  private _isStoreOpen: boolean = false;

  constructor(
    private _storage: StorageService,
    private _changeDetectRef: ChangeDetectorRef,
    public translate: TranslateService
  ) {}

  get drawerChevronIcon(): string {
    return this.getDrawerStatus() ? 'chevron-left' : 'chevron-right';
  }

  get isStoreOpen(): boolean {
    return this._isStoreOpen;
  }

  selectMenu(lang: any, _index: number) {
    this.translate.use(lang.code);
    this.emitLang.emit(lang.code);
  }

  onLanguageSelect(lang: any): void {
    if (!lang || this.activeProgress) return;
    this.selectMenu(lang, 0);
  }

  getDrawerStatus(): boolean {
    return this._storage.getDrawerStatus();
  }

  setDrawerStatus(val: boolean) {
    if (this._storage.getTokenTemp()) {
      this._storage.setDrawerStatusTemp(val);
    } else {
      this._storage.setDrawerStatus(val);
    }
    this._changeDetectRef.markForCheck();
  }

  toggleDrawerStatus() {
      this.getDrawerStatus() ? this.setDrawerStatus(false) : this.setDrawerStatus(true);
      this.sideBarSizeChanged.emit( this.getDrawerStatus() ? false : true);
  }

  getDrawerToolTip(): string {
    return this.getDrawerStatus() ? this.sideBarToolTip[0] : this.sideBarToolTip[1];
  }

  // Can't find any use for this after sidebar v2 redesign
  // getAccountEmail(): string {
  //   return this._storage.getAccount() ? this._storage.getAccount()['username'] : '';
  // }

  iconStoreToggle() {
    this._isStoreOpen = !this._isStoreOpen;
    this._changeDetectRef.markForCheck();
  }

  showStores(event?: Event) {
    const open = !this._isStoreOpen;
    this.showStoresHandler.emit({ open, event });
    this.iconStoreToggle();
  }

  // Can't find any use for this after sidebar v2 redesign
  // uploadHandlerFn(event) {
  //   this.uploadHandler.emit(event);
  // }

  checkIfAccountHasClients(): boolean {
    return this._storage.getClientUID() ? true : false;
  }
}
